import React, { useEffect, useRef, useState } from 'react'
import copy from 'copy-to-clipboard'
import {
  Button,
  CopyToClipboard,
  Modal,
  ModalInjectedProps,
  Tooltip,
} from '@sketch/components'
import { ModalHeader, ModalBody, CodeBlock } from './CodePreviewModal.styles'

import { SketchLayerCSSProperties } from '../../../../../../inspector'
import { ElementInfo } from '../../sections/Overview/ElementInfo'
import { useGenerateLayerCSS } from '../../useGenerateLayerCSS'

interface CodePreviewModalProps extends ModalInjectedProps {
  element: SketchLayerCSSProperties
}

export const CodePreviewModal = ({
  element,
  hideModal,
}: CodePreviewModalProps) => {
  const timeoutIdRef = useRef<number | null>(null)
  const [tooltipVisible, setTooltipVisible] = useState(false)

  const layerCSS = useGenerateLayerCSS(element)

  useEffect(() => {
    // Clear any existing timeout on unmount
    return () => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current)
      }
    }
  }, [])

  if (!element || !element.style) return null

  const handleCopyCode = () => {
    if (!layerCSS.css.length) return

    // Clear any existing timeout
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current)
    }

    copy(layerCSS.toString())
    setTooltipVisible(true)

    timeoutIdRef.current = window.setTimeout(() => {
      setTooltipVisible(false)
    }, CopyToClipboard.animationDuration)
  }

  return (
    <Modal autoFocusOnOpen={false} onCancel={hideModal}>
      <ModalHeader>
        <ElementInfo sketchElement={element} />
      </ModalHeader>
      <ModalBody>
        <CodeBlock styles={layerCSS.css} />
      </ModalBody>
      <Modal.Footer>
        <Button variant="secondary" onClick={hideModal}>
          Close
        </Button>
        <Tooltip visible={tooltipVisible} placement="top" content="Copied">
          <Button variant="primary" onClick={handleCopyCode}>
            Copy Code
          </Button>
        </Tooltip>
      </Modal.Footer>
    </Modal>
  )
}
